// latest: zhangmyh 2017-3-25 1:18 PM
/* global $ u */

let _config
function init (refer) {
  let state = 0
  if (_config.savedOrgNames && _config.savedOrgNames.length > 0) {
    state += 1
  }
  if (_config.publishOrgNames && _config.publishOrgNames.length > 0) {
    state += 2
  }
  let vm = {
    saved: _config.savedOrgNames,
    published: _config.publishOrgNames,
    state
  }
  let app = u.createApp()
  app.init(vm, $('#refer_remind_result')[0])
  refer.registerSubmitFunc(() => {
    return true
  })
}

let template = require('./index.html')
export default function (config) {
  _config = config
  return {
    init,
    template
  }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/evalRemindResult/index.js